module.exports = __webpack_public_path__ + "icons.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/dist/themes/default/assets/fonts/icons.eot
// module id = ../../../../../src/assets/dist/themes/default/assets/fonts/icons.eot
// module chunks = styles